import { render, staticRenderFns } from "./SelectorIdioma.vue?vue&type=template&id=f3ee4398&scoped=true"
import script from "./SelectorIdioma.vue?vue&type=script&lang=js"
export * from "./SelectorIdioma.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3ee4398",
  null
  
)

export default component.exports